/* eslint-disable @next/next/no-img-element */
import { PAYMENT_STATUS, PAYMENT_TYPE, QR_BLUR_DATA_URL } from "@/common/const";
import { cn } from "@/lib/utils";
import getIcon from "@/utils/getIcon";
import { Modal, ModalContent, Skeleton, useDisclosure } from "@nextui-org/react";
import Image from "next/image";
import CopyTextComponent from "../CopyTextComponent";
import DynamicFontSize from "../DynamicFontSize";
import DynamicSizeIcon from "../DynamicSizeIcon";
import FormatterNumber from "../FormatterNumber";
import LeftGradientBorder from "../LeftGradientBorder";
import ModalLayout from "../ModalLayout";
import PrimaryButton, { ButtonStatus } from "../PrimaryButton";
import SecondaryButton from "../SecondaryButton";
import { useGlobalData } from "@/contexts/GlobalData";
import useCountdown from "@/hook/useCountDown";
import { useEffect, useState } from "react";
import { useNotify } from "@/contexts/NotifyProvider";
import * as htmlToImage from "html-to-image";
import { QRCode } from "react-qrcode-logo";
import BottomGradientBorder from "../BottomGradientBorder";
import clsx from "clsx";
import styles from "./index.module.css";
import useFetchApi from "@/hook/useFetch";
import checkPaymentStatusService from "@/services/payment/checkPaymentStatusService";
import { useRouter } from "next/navigation";
import dynamic from "next/dynamic";
import { decodeQrFromImageUrl } from "@/utils/decodeQr";
type TransferWithSubPaymentGatewayProps = {
  isQrOpen: boolean;
  onOpenChangeOrOpen: (isOpen: boolean) => void;
  onCloseOrOpen: () => void;
  transferData: any;
  prefixFromParent?: string;
};
function TransferWithSubPaymentGateway({
  isQrOpen,
  onOpenChangeOrOpen,
  onCloseOrOpen,
  transferData,
  prefixFromParent
}: TransferWithSubPaymentGatewayProps) {
  const {
    isOpen,
    onOpen,
    onOpenChange,
    onClose
  } = useDisclosure();
  const [isShareStatus, setIsShareStatus] = useState<ButtonStatus>("normal");
  const {
    translate,
    getImageFromCMS,
    triggerHapticFeedBack,
    runEffectNavigation
  } = useGlobalData();
  const noti = useNotify();
  const {
    seconds,
    minutes
  } = useCountdown(transferData?.timeout);
  const {
    buttonLoading,
    fetchData: checkPaymentStatus
  } = useFetchApi(checkPaymentStatusService);
  const router = useRouter();
  const [qr, setQr] = useState<string>();
  const handleTransferred = (code: string) => {
    checkPaymentStatus(code, res => {
      if (res.data.status != PAYMENT_STATUS.SUCCESS) {
        onOpen();
      } else {
        router.push("/activity");
      }
    }, error => {
      console.error("handleTransferred error", error);
    });
    runEffectNavigation();
  };
  function dataURItoBlob(dataURI: string) {
    var byteString = atob(dataURI.split(",")[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], {
      type: "image/png"
    });
  }
  const handleShare = (shareData: string | any) => {
    console.log(shareData, "shareData");
    const data = typeof shareData == "string" ? {
      url: shareData
    } : {
      files: [shareData],
      title: "TBK deposit",
      text: "TBK deposit"
    };
    if (navigator.canShare && navigator.canShare(data)) {
      navigator.share(data).then(() => {
        triggerHapticFeedBack("success");
        setIsShareStatus("success");
        setTimeout(() => {
          setIsShareStatus("normal");
        }, 2000);
        console.log("Share was successful.");
      }).catch(error => console.error("Sharing failed", error)).finally(() => {
        setIsShareStatus("normal");
      });
    } else {
      console.log("Sharing not supported");
      noti?.error(translate("share not supported"));
      setIsShareStatus("error");
      setTimeout(() => {
        setIsShareStatus("normal");
      }, 3000);
    }
  };
  const handleCapture = async (element: HTMLElement) => {
    const result = await htmlToImage.toCanvas(element, {
      cacheBust: true,
      quality: 0.95,
      width: element.offsetWidth,
      height: element.offsetHeight,
      canvasWidth: element.offsetWidth,
      canvasHeight: element.offsetHeight,
      skipFonts: true,
      backgroundColor: "none"
    });
    return result;
  };
  const handleDownload = async () => {
    setIsShareStatus("loading");
    const captureElement = document.getElementById("qr-capture") as HTMLElement;
    try {
      let retry = 0;
      let condition = true;
      let fileData: any = null;
      while (condition && retry <= 10) {
        const result = await handleCapture(captureElement);
        const file = dataURItoBlob(result.toDataURL("image/png"));
        console.log("🚀 ~ handleDownload ~ file:", file.size);
        retry++;
        if (file.size > 0.1 * 1024 * 1024) {
          const fileShare = new File([file], `qr-sub-payment.png`, {
            type: "image/png"
          });
          handleShare(fileShare);
          fileData = file;
          condition = false;
        }
      }
      if (!fileData) {
        setIsShareStatus("error");
        setTimeout(() => {
          setIsShareStatus("normal");
        }, 3000);
      }
    } catch (error) {
      console.error("Error capturing the image:", error);
      setIsShareStatus("error");
      setTimeout(() => {
        setIsShareStatus("normal");
      }, 3000);
    }
  };
  // Ví dụ gọi
  useEffect(() => {
    if (!transferData?.infoPayment?.qr_code) return;
    decodeQrFromImageUrl(transferData?.infoPayment?.qr_code).then(data => {
      setQr(data as string);
    }).catch(err => console.error(err));
  }, [transferData]);
  return <Modal isOpen={isQrOpen} placement="bottom" onOpenChange={onOpenChangeOrOpen} isDismissable={false} hideCloseButton backdrop="blur" data-sentry-element="Modal" data-sentry-component="TransferWithSubPaymentGateway" data-sentry-source-file="index.tsx">
            <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]" data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
                <ModalLayout modalKey="830ce6bc-486e-4e55-8474-b1c54670fg15d0edwdfhf" title={translate(prefixFromParent + "deposit sub payment")} onClose={() => {
        onCloseOrOpen();
      }} data-sentry-element="ModalLayout" data-sentry-source-file="index.tsx">
                    <div className="flex flex-col justify-center gap-4">
                        <LeftGradientBorder className="rounded-[20px] flex flex-col" background="vision_light" data-sentry-element="LeftGradientBorder" data-sentry-source-file="index.tsx">
                            <div className="p-4 flex flex-col items-center gap-2">
                                <DynamicFontSize fontSize={11} className="font-medium text-description text-center" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                    {translate(prefixFromParent + "helper")}
                                </DynamicFontSize>
                                {minutes == 0 && seconds == 0 ? <>
                                        <DynamicFontSize fontSize={14} className="font-medium text-error text-center">
                                            {translate(prefixFromParent + "timeout")}
                                        </DynamicFontSize>
                                        <DynamicFontSize fontSize={11} className="text-white text-center">
                                            {translate(prefixFromParent + "please try again")}
                                        </DynamicFontSize>
                                    </> : <DynamicFontSize fontSize={11} className="font-medium text-description flex items-center">
                                        {translate(prefixFromParent + "update after")}
                                        <Skeleton isLoaded={!isNaN(minutes) || !isNaN(seconds)} className="w-fit mx-auto bg-default/10 before:opacity-20 rounded-md">
                                            <DynamicFontSize fontSize={16} className=" text-secondary">
                                                {minutes < 10 ? `0${minutes}` : isNaN(minutes) ? "--" : minutes}:
                                                {seconds < 10 ? `0${seconds}` : isNaN(seconds) ? "--" : seconds}
                                            </DynamicFontSize>
                                        </Skeleton>
                                    </DynamicFontSize>}
                            </div>
                            <div className={cn("py-[28px] px-[72px] rounded-3xl shadow-card relative overflow-hidden flex justify-center", minutes == 0 && seconds == 0 && "blur-sm")} id="qr-capture" style={{
              background: `url(${getImageFromCMS("bg_deposit_bank", "jpg")}) lightgray 50% / cover no-repeat`
            }}>
                                <div className="z-10 relative overflow-hidden rounded-3xl flex flex-col max-w-[200px] h-[286px] justify-between items-center w-full pt-[14px] pb-[10px]" style={{
                background: `url(${getImageFromCMS("bg_qr", "png")}) transparent 50% / cover no-repeat`
              }}>
                                    <div className="z-10 flex flex-col items-center">
                                        <Skeleton isLoaded={!!qr} data-sentry-element="Skeleton" data-sentry-source-file="index.tsx">
                                            <QRCode value={qr} size={130} ecLevel="H" logoImage={getImageFromCMS("airpay")} logoPadding={6} logoPaddingStyle="circle" logoHeight={18} logoWidth={18} data-sentry-element="QRCode" data-sentry-source-file="index.tsx" />
                                        </Skeleton>
                                        <DynamicFontSize fontSize={18} className="font-semibold text-black font-primary" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                            <FormatterNumber value={transferData?.infoPayment?.amount} unit=" VND" unitCustomStyle="text-base text-description" useCompact={false} data-sentry-element="FormatterNumber" data-sentry-source-file="index.tsx" />
                                        </DynamicFontSize>
                                    </div>
                                    <div className="flex flex-col gap-1 items-center relative">
                                        <DynamicFontSize fontSize={14} className="font-medium font-primary whitespace-nowrap w-full text-center" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                            {/* {translate(prefixFromParent + "bank account name")} */}
                                            {transferData?.infoPayment?.metadata?.bank_account?.account_name}
                                        </DynamicFontSize>
                                        <DynamicFontSize fontSize={11} className="text-description font-primary" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                            {/* {translate(prefixFromParent + "bank name")} */}
                                            {transferData?.infoPayment?.metadata?.bank_account?.account_number}
                                        </DynamicFontSize>
                                        <CopyTextComponent value={transferData?.infoPayment?.orderId} className="flex items-center gap-1 w-full relative" data-sentry-element="CopyTextComponent" data-sentry-source-file="index.tsx">
                                            <DynamicFontSize fontSize={11} className="font-semibold font-primary" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                                {transferData?.infoPayment?.orderId}
                                            </DynamicFontSize>
                                            <Image alt="copy" src={getIcon("copy_black")} width={16} height={16} id="copy-icon" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
                                        </CopyTextComponent>
                                    </div>
                                </div>
                            </div>
                        </LeftGradientBorder>
                        <div className="flex items-center justify-between gap-2 w-full">
                            <Skeleton isLoaded={!isNaN(minutes) || !isNaN(seconds)} className="flex-1 rounded-full bg-default/10 before:opacity-20" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx">
                                <SecondaryButton onClick={() => {
                handleTransferred(transferData?.infoPayment?.orderId);
              }} className="flex-1 !bg-vision-light border-vision-light !text-sm !font-semibold w-full" status={buttonLoading} statusKey={prefixFromParent + "Transferred"} data-sentry-element="SecondaryButton" data-sentry-source-file="index.tsx" />
                            </Skeleton>
                            <Skeleton isLoaded={!isNaN(minutes) || !isNaN(seconds)} className="flex-1 rounded-full bg-default/10 before:opacity-20" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx">
                                <PrimaryButton onClick={handleDownload} className="flex-1 flex items-center gap-2 justify-center w-full" status={isShareStatus} data-sentry-element="PrimaryButton" data-sentry-source-file="index.tsx">
                                    <DynamicSizeIcon icon={getIcon("share-black")} width={24} height={24} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx" />
                                    <DynamicFontSize data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">{translate(prefixFromParent + "share")}</DynamicFontSize>
                                </PrimaryButton>
                            </Skeleton>
                        </div>
                    </div>
                </ModalLayout>
            </ModalContent>
            {isOpen && <div className={clsx(styles.appear_tooltip_modal, "fixed inset-0 bg-black/[0.64] size-full flex z-[9999]")} onClick={() => onClose()}>
                    <BottomGradientBorder onClick={(e: any) => e?.stopPropagation()} background="bottom_to_top" className={clsx("p-3 rounded-2xl m-auto !max-w-[calc(100%-32px)]", styles.appear_tooltip_modal_content)}>
                        <DynamicFontSize fontSize={18} className="text-white flex items-center gap-1.5">
                            {translate(prefixFromParent + "Memo explain title")}
                            <DynamicSizeIcon width={24} icon={getIcon("close_modal")} className="ml-auto cursor-pointer" onClick={() => onClose()} />
                        </DynamicFontSize>
                        <div className="divider my-5"></div>
                        <DynamicFontSize fontSize={13} className="flex flex-col gap-3 text-description">
                            <span className="">{translate(prefixFromParent + "warning nation des1")}</span>
                            <span className="">{translate(prefixFromParent + "warning nation des2")}</span>
                            <PrimaryButton onClick={() => {
            onClose();
          }} className="w-full" statusKey={prefixFromParent + "confirm memo explain"}></PrimaryButton>
                        </DynamicFontSize>
                    </BottomGradientBorder>
                </div>}
        </Modal>;
}
export default TransferWithSubPaymentGateway;